/*
  Quote form prefill from links such as
  /pages/request-quote?category=…&product=…&enquiry=sample&buyer=sports-club
  - category: selects the matching product category (exact, case-insensitive).
  - product: fills "Product of interest".
  - enquiry / buyer: select the option whose data-kx-key matches (lowercase letters, digits, hyphens).
  Fields the visitor has already filled (or values restored after an error) are left alone,
  and unknown keys are ignored. Without JavaScript the form works as normal with empty fields.
*/
(function () {
  const MAX_LENGTH = 150;
  const KEY_LENGTH = 60;

  function readKey(params, name) {
    const value = (params.get(name) || '').trim().toLowerCase().slice(0, KEY_LENGTH);
    return /^[a-z0-9-]+$/.test(value) ? value : '';
  }

  function prefill(root) {
    const params = new URLSearchParams(window.location.search);
    const category = (params.get('category') || '').trim().slice(0, MAX_LENGTH);
    const product = (params.get('product') || '').trim().slice(0, MAX_LENGTH);
    const enquiry = readKey(params, 'enquiry');
    const buyer = readKey(params, 'buyer');
    if (!category && !product && !enquiry && !buyer) return;

    root.querySelectorAll('[data-kx-quote-prefill]').forEach((container) => {
      const select = container.querySelector('select[name="contact[Product category]"]');
      if (select && category && !select.value) {
        const wanted = category.toLowerCase();
        const match = Array.from(select.options).find((option) => option.value.toLowerCase() === wanted);
        if (match) select.value = match.value;
      }

      const input = container.querySelector('input[name="contact[Product of interest]"]');
      if (input && product && !input.value) input.value = product;

      const radios = Array.from(container.querySelectorAll('input[name="contact[Enquiry type]"]'));
      if (enquiry && radios.length && !radios.some((radio) => radio.checked)) {
        const radio = radios.find((candidate) => candidate.dataset.kxKey === enquiry);
        if (radio) radio.checked = true;
      }

      const buyerSelect = container.querySelector('select[name="contact[Buyer type]"]');
      if (buyerSelect && buyer && !buyerSelect.value) {
        const option = Array.from(buyerSelect.options).find((candidate) => candidate.dataset.kxKey === buyer);
        if (option) buyerSelect.value = option.value;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prefill(document));
  } else {
    prefill(document);
  }

  document.addEventListener('shopify:section:load', (event) => prefill(event.target));
})();
